import { getSiteInfo_mobile } from '@/api/mobile/basic'
import { getSiteInfo_desktop } from '@/api/desktop/basic'

const HOME_PAGE_LOTTERIES_DEFAULT = {
  pk10TukuTab: ['jspk10', 'wfpk10'],
  sixhcTukuTab: [
    'am6',
    'smam6',
    'js6',
    'amff6',
    'amsf6',
    'amwf6',
    'ff6',
    'sf6',
    'hk6',
    'nam6',
    'newam6'
  ],
  sscTukuTab: ['wfssc', 'jsssc']
}

const state = () => ({
  siteInfo: {},
  title: '',
  webSiteInfo: {},
  webTitle: '',
  tuku: {},
  webTukuTab: {
    sixhcTukuTab: [],
    pk10TukuTab: [],
    sscTukuTab: []
  },
  wapTukuTab: {
    sixhcTukuTab: [],
    pk10TukuTab: [],
    sscTukuTab: []
  }
})

const mutations = {
  SET_SITEINFO: (state, payload) => {
    state.siteInfo = Object.assign({}, state.siteInfo, payload)
    state.tuku = Object.assign({}, state.tuku, payload)
    state.wapTukuTab.sixhcTukuTab = Object.assign(
      [],
      state.siteInfo.siteSetting.homePageLotteries?.sixhcTukuTab ||
        HOME_PAGE_LOTTERIES_DEFAULT.sixhcTukuTab
    )
    state.wapTukuTab.pk10TukuTab = Object.assign(
      [],
      state.siteInfo.siteSetting.homePageLotteries?.pk10TukuTab ||
        HOME_PAGE_LOTTERIES_DEFAULT.pk10TukuTab
    )
    state.wapTukuTab.sscTukuTab = Object.assign(
      [],
      state.siteInfo.siteSetting.homePageLotteries?.sscTukuTab ||
        HOME_PAGE_LOTTERIES_DEFAULT.sscTukuTab
    )
  },
  SET_TITLE: (state, payload) => {
    state.title = payload
  },
  SET_WEB_SITEINFO: (state, payload) => {
    state.webSiteInfo = Object.assign({}, state.webSiteInfo, payload)
    state.webTukuTab.sixhcTukuTab = Object.assign(
      [],
      state.webSiteInfo.siteSetting.homePageLotteries?.sixhcTukuTab ||
        HOME_PAGE_LOTTERIES_DEFAULT.sixhcTukuTab
    )
    state.webTukuTab.pk10TukuTab = Object.assign(
      [],
      state.webSiteInfo.siteSetting.homePageLotteries?.pk10TukuTab ||
        HOME_PAGE_LOTTERIES_DEFAULT.pk10TukuTab
    )
    state.webTukuTab.sscTukuTab = Object.assign(
      [],
      state.webSiteInfo.siteSetting.homePageLotteries?.sscTukuTab ||
        HOME_PAGE_LOTTERIES_DEFAULT.sscTukuTab
    )
  },
  SET_WEB_TITLE: (state, payload) => {
    state.webTitle = payload
  }
}

const actions = {
  async getSiteInfo({ commit }) {
    const [siteInfo, error] = await getSiteInfo_mobile()
    if (error) return
    commit('SET_SITEINFO', siteInfo)
  },
  async getWebSiteInfo({ commit }) {
    const [siteInfo, error] = await getSiteInfo_desktop()
    if (error) return
    commit('SET_WEB_SITEINFO', siteInfo)
  }
}

export { state, mutations, actions }
